import { apiRoutes } from 'constant';

import { post } from './http';

export const requestLogin = (email, password) => post(apiRoutes.LOGIN, { email, password });

export const requestImpersonate = code => post(apiRoutes.IMPERSONATE, { code });
